import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ShippingRulePresetsApiAdapter } from '../adapters/ShippingRulePresetsApiAdapter';

export const useShippingRulePresets = () => {
  const adapter = useMemo(() => {
    const httpClient = createHttpClient(apiClientWH);
    return new ShippingRulePresetsApiAdapter(httpClient);
  }, []);

  const {
    data,
    isLoading: loading,
    error,
  } = useQuery({
    queryKey: ['shipping-rule-presets'],
    queryFn: async () => {
      const response = await adapter.getShippingRulePresets({ per_page: 100 });
      return response.data ?? [];
    },
    staleTime: 5 * 60 * 1000,
  });

  return {
    presets: data ?? [],
    loading,
    error,
  };
};
